import { carrierLabel } from '../lib/carrier-label'

// The one place a carrier's display name is rendered; the raw slug stays in the tooltip.
// `raw` shows the quoted slug, so case and whitespace variants flagged as duplicates stay distinguishable.
export function CarrierName({ slug, raw = false }: { slug: string; raw?: boolean }) {
  return <span title={slug}>{raw ? JSON.stringify(slug) : carrierLabel(slug)}</span>
}
